import Swiper from 'swiper';

const initBlockClothesSlider = () => {
    const blocks = Array.from(document.querySelectorAll('.block-clothes-slider'));

    blocks.forEach(block => {
        if (block.inited) {
            return;
        }
        block.inited = true;

        new Swiper(block, {
            loop: false,
            speed: 1000, 
            allowTouchMove: true, 
            on: {
                init: () => {
                    block.classList.add('block-clothes-slider--init');
                },
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 2,
                    spaceBetween: 2,
                },
    
                // when window width is >= 600px
                600: {
                    slidesPerView: 3,
                    spaceBetween: 2,
                },
    
                // when window width is >= 1200px
                900: {
                    slidesPerView: 4, 
                    spaceBetween: 2,
                }
            }
        })
    });

}

initBlockClothesSlider();

export default initBlockClothesSlider;